import React from 'react';
import { BrowserRouter } from 'react-router-dom';
import AppRouter from './router/AppRouter.jsx';
import MainLayout from './layouts/MainLayout.jsx';

const App = () => (
    <BrowserRouter>
        <MainLayout>
            <AppRouter />
        </MainLayout>
    </BrowserRouter>
);

export default App;
